import { isDev } from '../env';

/** List of known cookies to sync with lucid.app
 *
 * @see https://git.lucidutil.com/projects/LUCID/repos/main/browse/cake/app/webroot/ts/cookiesync/app/cookieconfig.ts
 */
export const formatCookieDomain = (hostname: string, port = ''): string => {
  const productionUrls = ['lucidchart.com', 'lucidscale.com', 'lucidspark.com', 'lucid.co', 'lucidforeducation.com'];
  const preProductionUrls = [
    'preprodchart.com',
    'lucidchart.preprod.lucidmarketingtest.com',
    'lucidscale.preprod.lucidmarketingtest.com',
    'lucidspark.preprod.lucidmarketingtest.com',
    'lucidco.preprod.lucidmarketingtest.com',
    'lucidedu.preprod.lucidmarketingtest.com',
    'preprodgo.com',
  ];

  const lucidAppUrl = 'lucid.app';
  const lucidPreprodAppUrl = 'lucidpreprod.app';
  const lucidDevAppUrl = 'luciddev.app';
  const lucidStagingAppUrl = 'lucidstaging.app';
  const marketingDomainHost = 'lucidmarketingtest.com';
  const marketingDevDomain = `dev.${marketingDomainHost}`;
  const marketingStagingDomain = `staging.${marketingDomainHost}`;

  if (productionUrls.includes(hostname)) {
    return lucidAppUrl;
  }

  if (preProductionUrls.includes(hostname)) {
    return lucidPreprodAppUrl;
  }

  if (hostname.endsWith(marketingDevDomain)) {
    return hostname.replace(marketingDevDomain, lucidDevAppUrl);
  }

  if (hostname.endsWith(marketingStagingDomain)) {
    return hostname.replace(marketingStagingDomain, lucidStagingAppUrl);
  }

  if (hostname === `localhost${port ? `:${port}` : ''}`) {
    return hostname.replace('localhost', isDev() ? `localhost${port ? `:${port}` : ''}` : '');
  }

  return hostname;
};

const setupCookieSync = (location: Location | null) => {
  if (!location) return null;
  const { hostname, protocol, port } = location;
  const iframeLocation = formatCookieDomain(hostname, port);
  const isLocalhost = iframeLocation === `localhost${port ? `:${port}` : ''}`;
  const syncCookies = document.createElement('iframe');

  syncCookies.style.display = 'none';
  syncCookies.src = `${protocol}//${iframeLocation}/synchronizeCookies?responseDomain=${
    !isLocalhost ? hostname : iframeLocation
  }`;
  syncCookies.className = 'cookieSyncIframe';

  document.getElementsByTagName('body')[0].appendChild(syncCookies);

  const syncAllCookies = () => {
    if (window && window.lucid) {
      window.lucid.cookieSyncClient.init(iframeLocation);
      window.lucid.cookieSyncClient.syncAllCookies();
      window.lucid.cookieSyncClient.syncAllMarketingCookies();
    }
  };

  setInterval(() => {
    syncAllCookies();
  }, 1000);
};

export default setupCookieSync;
